import { render } from "./user-list.vue?vue&type=template&id=64b2e057&scoped=true"
import script from "./user-list.vue?vue&type=script&lang=js"
export * from "./user-list.vue?vue&type=script&lang=js"

import "./user-list.vue?vue&type=style&index=0&id=64b2e057&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64b2e057"]])

export default __exports__